<template>
  <button
    class="control-button"
    @click="emit('click')"
    :aria-label="isFullscreen ? t('player.controls.exitFullscreen') : t('player.controls.fullscreen')"
    :data-tooltip="(isFullscreen ? t('player.controls.exitFullscreen') : t('player.controls.fullscreen')) + ' (f)'"
    v-html="isFullscreen ? exitFullscreenIcon : fullscreenIcon"
  />
</template>

<script setup lang="ts">
import { fullscreenIcon, exitFullscreenIcon } from '../../assets/icons'
import { useVideoI18n } from '../../i18n'

defineProps<{
  isFullscreen: boolean
}>()

const emit = defineEmits<{
  click: []
}>()

const { t } = useVideoI18n()
</script>

<style scoped>
/* Styles are in main.scss */
</style>
